export const DOCUMENT_TYPE_FINANCE_PAGE = 'finance-page';
